import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import "./CustomerForm.css";


function StoreSelector({ value, onChange }) {
  const [stores, setStores] = useState([]);
  const [open, setOpen] = useState(false);
  const [tapCount, setTapCount] = useState(0);

  // fetch stores
  useEffect(() => {
    // fetch("https://hamarachoiceschemes.com/api/store/")
    // fetch("https://test.hamarachoiceschemes.com/api/store/")
    fetch("http://localhost:8000/api/store/")
      .then((res) => res.json())
      .then((data) => {
        setStores(data);
        if (!value && data.length) {
          setOpen(true); // default
        }
      });
  }, []);

  // triple tap handler
  const handleTap = () => {
    setTapCount((prev) => {
      const next = prev + 1;
      if (next === 2) {
        setOpen(true);
        return 0;
      }
      setTimeout(() => setTapCount(0), 600);
      return next;
    });
  };

  return (
    <>
      {/* Display text */}
      <Box
        onClick={handleTap}
        sx={{
          textAlign: "center",
          mt: 2,
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <Typography className="store-text-head">
          <p className="store-text">Store: {value?.name || "Not Selected"}</p>
        </Typography>
      </Box>

        {/* Popup */}
        <Dialog
            open={open}
            onClose={(event, reason) => {
              // prevent closing on backdrop click or escape key
              if (reason === "backdropClick" || reason === "escapeKeyDown") {
                return;
              }
              setOpen(false);
            }}
            disableEscapeKeyDown
            className="store-container"
            slots={{ paper: "div" }}
            slotProps={{
              paper: {
                className: "store-dialog-paper",
              },
            }}
        >
            <DialogTitle>
                Select Store <span style={{ color: "red" }}>*</span>
            </DialogTitle>
            <DialogContent>
                <div className="store-grid">
                    {stores.map((store) => {
                    const isSelected = value?.id === store.id;

                    return (
                        <div
                          key={store.id}
                          className={`store-card ${isSelected ? "selected" : ""}`}
                          onClick={() => {
                              onChange(store);
                              setOpen(false);
                          }}
                        >
                          <div className="store-name">{store.name}</div>
                        </div>
                    );
                    })}
                </div>
            </DialogContent>
        </Dialog>
    </>
  );
}

export default StoreSelector;
